export const ListQueryKey = 'projectInnerTransRecords';
export const DetailQueryKey = 'projectInnerTransRecord';
export const Urls = {
  selectUrl: '/innerTransRecord/list',
  updateUrl: '/innerTransRecord/update',
  deleteUrl: '/innerTransRecord/delete',
  createUrl: '/innerTransRecord/create',
  detailUrl: '/innerTransRecord/info'
};